import universal from 'react-universal-component'

export const UniversalMeetingDashboard = universal(props => import('./MeetingDashboard'))